import request from '@shared/api/request';
import { API_MODULES_PATH } from '@shared/constants/pathsConstants';

export function getModules() {
    return request.get(`/${API_MODULES_PATH}/`);
}

export function addModule(moduleData) {
    return request.post(`/${API_MODULES_PATH}/`, moduleData);
}

export function editModule(id, name, parentId) {
    return request.patch(`/${API_MODULES_PATH}/${id}/`, { name: name, parent: parentId });
}

export function moveObjectsToAnotherModule(moduleIdToDelete, moduleIdToMove) {
    return request.post(`/${API_MODULES_PATH}/${moduleIdToDelete}/`, { module: moduleIdToMove });
}

export function deleteModule(id) {
    return request.delete(`/${API_MODULES_PATH}/${id}/`);
}
